
import { defineComponent, reactive } from "vue";
import gsap from "gsap";

// State object.
interface State {
  mode: string;
  isShowNotice: boolean;
}

// Component definition
export default defineComponent({
  name: "OverScrollNotice",
  props: {
    mode: {
      type: String,
      required: true
    }
  },
  setup(props) {
    const state = reactive<State>({
      mode: props.mode,
      isShowNotice: false
    });

    // Show notice for over click to turn pages.
    const showNotice = () => {
      if (!state.isShowNotice) {
        state.isShowNotice = true;
        window.setTimeout(() => {
          state.isShowNotice = false;
        }, 3000);

        // show notice
        const targetClass = `.notice.${state.mode}`;
        gsap.from(targetClass, {
          x: `${state.mode == "first" ? "" : "-"}4rem`,
          ease: "elastic.out(1.2,0.5)",
          duration: 1
        });
      }
    };

    const hideNotice = () => {
      if (state.isShowNotice) {
        state.isShowNotice = false;
      }
    };

    return {
      state,
      showNotice,
      hideNotice
    };
  }
});
